"use client";

import Image from "next/image";
import Link from "next/link";
import { Heart, LogOut, ShoppingCart } from "lucide-react";
import { usePathname, useSearchParams } from "next/navigation";
import { cartApi } from "@/src/features/cart/cartApi";
import { wishlistApi } from "@/src/features/wishlist/wishlistApi";
import { useAppSelector } from "@/src/store/hooks";
import { selectHeaderBadges } from "@/src/store/selectors/headerSelectors";
import { ROUTES } from "@/src/constants/routes";

export default function MobileTopBar() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const { cartCount, wishlistCount } = useAppSelector(selectHeaderBadges);
  cartApi.useGetCartQuery(undefined, {
    skip: false,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  wishlistApi.useGetWishlistQuery(undefined, {
    skip: false,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  const currentQuery = searchParams.toString();
  const redirectPath = `${pathname}${currentQuery ? `?${currentQuery}` : ""}`;
  const badgeClassName =
    "absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-4 items-center justify-center rounded-full border border-white bg-[#ee376a] px-1 text-[10px] font-bold leading-none !text-white shadow-[0_6px_14px_rgba(238,55,106,0.28)]";
  const loginHref = `${ROUTES.LOGIN}?${new URLSearchParams({
    redirect: redirectPath,
  }).toString()}`;

  return (
    <div
      className="fixed inset-x-0 top-0 z-50 flex items-center justify-between border-b border-gray-100 bg-white px-4 lg:hidden"
      style={{ height: "52px" }}
    >
      <div className="flex items-center gap-2">
        {isAuthenticated ? (
          <Link
            href="/logout"
            className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-full text-[var(--color-ink)] transition-colors hover:bg-[rgba(111,127,95,0.08)]"
            aria-label="تسجيل الخروج"
          >
            <LogOut className="h-5 w-5 stroke-[2.1]" />
          </Link>
        ) : null}
        {!isAuthenticated ? (
          <Link
            href={loginHref}
            className="inline-flex h-9 items-center rounded-full border border-[rgba(238,49,106,0.42)] bg-white px-3 text-[0.78rem] font-bold text-[var(--color-ink)] shadow-[0_8px_18px_rgba(238,49,106,0.08)]"
            aria-label="تسجيل الدخول"
          >
            تسجيل الدخول
          </Link>
        ) : null}
      </div>

      <Link href="/" className="absolute left-1/2 -translate-x-1/2">
        <Image
          src="/Office%20Furniture/image-removebg-preview.png"
          alt="YUMA"
          width={92}
          height={36}
          preload
          fetchPriority="high"
          quality={60}
          className="object-contain"
        />
      </Link>

      <div className="flex items-center gap-2">
        <Link
          href={ROUTES.WISHLIST}
          className="relative inline-flex h-9 w-9 flex-none items-center justify-center rounded-full text-[var(--color-ink)] transition-colors hover:bg-[rgba(111,127,95,0.08)]"
          aria-label="المفضلة"
        >
          <Heart className="h-5 w-5 stroke-[2.1]" />
          {wishlistCount > 0 ? (
            <span className={badgeClassName}>{wishlistCount}</span>
          ) : null}
        </Link>
        <Link
          href={ROUTES.CART}
          className="relative inline-flex h-9 w-9 flex-none items-center justify-center rounded-full text-[var(--color-ink)] transition-colors hover:bg-[rgba(111,127,95,0.08)]"
          aria-label="السلة"
        >
          <ShoppingCart className="h-5 w-5 stroke-[2.1]" />
          {cartCount > 0 ? (
            <span className={badgeClassName}>{cartCount}</span>
          ) : null}
        </Link>
      </div>
    </div>
  );
}
